import { QueryClient } from "@tanstack/react-query"

import { isNotFoundError } from "@/api/trpcErrors"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A missing session never becomes found, retrying only delays the error screen
      retry: (failureCount, error) => !isNotFoundError(error) && failureCount < 1,
      networkMode: "offlineFirst",
    },
    mutations: { networkMode: "offlineFirst" },
  },
})
